import { Link } from 'react-router-dom';
import { FaTable, FaDatabase, FaBrain, FaChartBar } from "react-icons/fa"; // Import icons

const Cards = () => {
  return (
    <div className='w-full py-24 px-4 bg-gray-50/50 dark:bg-[#0B1120] relative transition-colors duration-300'>
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:20px_20px] opacity-20 pointer-events-none"></div>

      <div className='max-w-[1240px] mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10 pt-12'>

        {/* SQL Course - Featured */}
        <div className='w-full shadow-2xl bg-white dark:bg-[#0F1623] flex flex-col p-6 my-4 rounded-xl hover:scale-105 duration-300 border border-blue-500/30 relative group'>
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-emerald-500 rounded-t-xl"></div>
          <div className="w-16 h-16 mx-auto mt-[-3rem] bg-indigo-50 dark:bg-[#0B1120] rounded-2xl flex items-center justify-center border border-blue-500/50 shadow-[0_0_30px_-5px_rgba(37,99,235,0.3)] relative z-10">
            <FaDatabase className="text-blue-500 dark:text-blue-400 text-3xl" />
          </div>
          <h2 className='text-xl font-bold text-center py-6 text-gray-900 dark:text-white font-sans'>SQL Practice</h2>
          <div className='text-center font-medium text-gray-600 dark:text-gray-300 text-sm flex-1'>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Interactive SQL Editor</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Real Business Case Studies</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Instant Feedback System</p>
          </div>
          <Link to="/exercises" className='block w-full mt-auto'>
            <button className='bg-blue-600 hover:bg-blue-500 text-white w-full rounded-lg font-medium my-6 px-6 py-3 shadow-lg shadow-blue-900/40 transition-all'>Start Practicing</button>
          </Link>
        </div>

        {/* Data Viz Course */}
        <div className='w-full shadow-2xl bg-white dark:bg-[#0F1623] flex flex-col p-6 my-4 rounded-xl hover:scale-105 duration-300 border border-orange-500/30 relative group'>
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 to-amber-400 rounded-t-xl"></div>
          <div className="w-16 h-16 mx-auto mt-[-3rem] bg-orange-50 dark:bg-[#0B1120] rounded-2xl flex items-center justify-center border border-orange-500/50 shadow-[0_0_30px_-5px_rgba(249,115,22,0.3)] relative z-10">
            <FaChartBar className="text-orange-500 text-3xl" />
          </div>
          <h2 className='text-xl font-bold text-center py-6 text-gray-900 dark:text-white font-sans'>Data Visualization</h2>
          <div className='text-center font-medium text-gray-600 dark:text-gray-300 text-sm flex-1'>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Interactive Chart Builder</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>5 Chart Modules</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Real Dataset Case Studies</p>
          </div>
          <Link to="/exercises/data-viz" className='block w-full mt-auto'>
            <button className='bg-orange-500 hover:bg-orange-400 text-white w-full rounded-lg font-medium my-6 px-6 py-3 shadow-lg shadow-orange-900/30 transition-all'>Explore Charts</button>
          </Link>
        </div>

        {/* SQL Cheatsheet */}
        <div className='w-full shadow-lg bg-white dark:bg-[#162032] flex flex-col p-6 my-4 rounded-xl hover:scale-105 duration-300 border border-gray-200 dark:border-gray-800 hover:border-gray-300 dark:hover:border-gray-600 transition-all group'>
          <div className="w-16 h-16 mx-auto mt-[-3rem] bg-gray-50 dark:bg-[#0A1220] rounded-2xl flex items-center justify-center border border-gray-200 dark:border-gray-700 group-hover:border-orange-500/50 transition-colors shadow-xl">
            <FaTable className="text-orange-500 text-3xl" />
          </div>
          <h2 className='text-xl font-bold text-center py-6 text-gray-900 dark:text-white font-sans'>SQL Cheatsheet</h2>
          <div className='text-center font-medium text-gray-600 dark:text-gray-400 text-sm flex-1'>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Instant Syntax Lookup</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Complex Joins Made Simple</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Window Functions & CTEs</p>
          </div>
          <Link to="/resources/sql-cheatsheet" className='block w-full mt-auto'>
            <button className='bg-orange-50 hover:bg-orange-100/50 border-orange-100 text-orange-600 dark:bg-white/5 dark:hover:bg-white/10 dark:text-orange-400 w-full rounded-lg font-medium my-6 px-6 py-3 border dark:border-white/5 hover:border-orange-500/30 transition-all'>
              View Cheatsheet
            </button>
          </Link>
        </div>

        {/* Machine Learning Course */}
        <div className='w-full shadow-lg bg-white dark:bg-[#162032] flex flex-col p-6 my-4 rounded-xl hover:scale-105 duration-300 border border-gray-200 dark:border-gray-800 hover:border-gray-300 dark:hover:border-gray-600 transition-all group'>
          <div className="w-16 h-16 mx-auto mt-[-3rem] bg-gray-50 dark:bg-[#0A1220] rounded-2xl flex items-center justify-center border border-gray-200 dark:border-gray-700 group-hover:border-purple-500/50 transition-colors shadow-xl">
            <FaBrain className="text-purple-500 text-3xl" />
          </div>
          <h2 className='text-xl font-bold text-center py-6 text-gray-900 dark:text-white font-sans'>ML Guides</h2>
          <div className='text-center font-medium text-gray-600 dark:text-gray-400 text-sm flex-1'>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>No-Nonsense Explanations</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Regression, Classification & More</p>
            <p className='py-2.5 border-b border-gray-100 dark:border-gray-800 mx-4'>Practical Python Implementation</p>
          </div>
          <Link to="/machine-learning" className='block w-full mt-auto'>
            <button className='bg-purple-50 hover:bg-purple-100/50 border-purple-100 text-purple-600 dark:bg-white/5 dark:hover:bg-white/10 dark:text-purple-400 w-full rounded-lg font-medium my-6 px-6 py-3 border dark:border-white/5 hover:border-purple-500/30 transition-all'>
              Read Guides
            </button>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Cards;
